module.exports = __webpack_public_path__ + "media/images/sidebar/sidebar-bg-ba1bb67c4e6ac4ccaf7082f39b063feb.png";